/*
 * @Author: yzr
 * @Date: 2020-11-24 09:37:03
 * @LastEditors: yzr
 * @LastEditTime: 2020-11-25 16:27:02
 */
import Contract from './contract.vue';

export default Contract;
